// src/features/analytics/useAnalyticsLiveByMedia.ts

import { useQuery } from '@tanstack/react-query';
import { AnalyticsApi } from './AnalyticsApi';
import {
  ANALYTICS_LIVE_POLL_INTERVAL_MS,
  ANALYTICS_QUERY_KEYS,
  TOP_CONTENT_DEFAULT_LIMIT,
} from '@/lib/constants/analytics';
import type { AnalyticsEnvelope, LiveByMediaData } from './types';

export interface UseAnalyticsLiveByMediaResult {
  liveByMedia: AnalyticsEnvelope<LiveByMediaData> | null;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  refetch: () => void;
}

/** Live concurrency by media — account scope only. Pass null cid to disable (network scope). */
export function useAnalyticsLiveByMedia(
  cid: number | null,
  limit: number = TOP_CONTENT_DEFAULT_LIMIT
): UseAnalyticsLiveByMediaResult {
  const query = useQuery({
    queryKey: ANALYTICS_QUERY_KEYS.liveByMedia(cid ?? 0, limit),
    queryFn: () => AnalyticsApi.getLiveByMedia(cid!, limit),
    enabled: cid !== null,
    staleTime: 0,
    refetchInterval: ANALYTICS_LIVE_POLL_INTERVAL_MS,
  });

  return {
    liveByMedia: query.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
